import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NgbOffcanvas, NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AcademicYearService } from '../../../../../core/services/academic-year.service';
import { ClassroomService } from '../../../../../core/services/classroom.service';
import { FileService } from '../../../../../core/services/file.service';
import { HealthControlService } from '../../../../../core/services/health-control.service';
import { StudentAyClassroomService } from '../../../../../core/services/student-ay-classroom.service';
import { StudentService } from '../../../../../core/services/student.service';
import { VaccinationService } from '../../../../../core/services/vaccination.service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../../core/utils/app-sweet-alert';
import { GlobalName } from '../../../../../core/utils/global-name';
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../layout/includes/header/header.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
    selector: 'app-vaccination',
    templateUrl: './vaccination.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule, NgxExtendedPdfViewerModule, NgxPaginationModule],
    styleUrls: ['./vaccination.component.css']
})
export class VaccinationComponent {
  @ViewChild('contentPDF') contentPDF:TemplateRef<any> | undefined
  pdfSrc = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";
  pdfViewLoader=false
  buttonsPermission :any|undefined;
  search_text=""
   structures:any[] =[]
   roles:any[] =[]
   periods:any[] =[]
   data:any[] =[]
   concerned:any[] =[]
   students:any[] =[]
   ays:any[] =[]
   classrooms:any[] =[]
   templates:any[] =[]
   sacs:any[] =[]
   selected_data:any;
   text:any;
   modalOption:any; 
   ayId:any;
   sacId:any;
   classroomId:any;
   isDtInitialized:boolean = false
   is_active=null
   loading=false
   tag="admin-infimary-vacctinations"
   pg={
     pageSize:10,
     p:0,
     total:0
   }
   role:any
   user:any
   type:any
 
 
   constructor(
    private spinnerService:NgxSpinnerService,
     private ayService:AcademicYearService,
     private fileService:FileService,
     private healthService:VaccinationService,
     private classroomService:ClassroomService,
     private studentService:StudentService,
     private sacService:StudentAyClassroomService,
     private toastrService:ToastrService,
     private offcanvasService: NgbOffcanvas,
       config: NgbModalConfig,
       private lsService:LocalStorageService,
     private modalService: NgbModal) {
      config.backdrop = 'static';
      config.keyboard = false;
      }
 
 
   ngOnInit(): void {
     
     this.user=this.lsService.get(GlobalName.userName)
       this.role=this.user.roles[0].name.toLowerCase()
       console.log(this.role)
     this.init()
     this.getActions()
   }
 
   init(){
     this.getSacs()
     this.getClassrooms()
     this.getAys()
   }
 

   loadData1(event:any){
    this.ayId=event
    this.getSacs()
   }

   loadData2(event:any){
    this.classroomId=event
    this.getSacs()
   }
 
   getSacs(){
    if(this.classroomId!=undefined || this.ayId != undefined){

      this.sacService.getAll(this.classroomId,this.ayId).subscribe((res:any)=>{
        this.sacs=res.data
      },
      (err:any)=>{
        AppErrorShow.showError("Gestion des vaccinations",err)

      })
    }
    
   }

 
   getClassrooms(){
     this.classroomService.getAll().subscribe((res:any)=>{
       this.classrooms=res.data
     },
     (err:any)=>{
      AppErrorShow.showError("Gestion des vaccinations",err)

     })
   }
 
   getAys(){
    this.ayService.getAll().subscribe((res:any)=>{
      this.ays=res.data
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des vaccinations",err)
    })
  }

  loadData(event:any){
    this.sacId=event,
    this.getAll()
  }
  getAll(){
    this.healthService.getAll(this.sacId).subscribe((res:any)=>{
      this.data=res.data
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des vaccinations",err)
    })
  }

   store(value:any){
     this.loading=true
     value['sac_id'] =this.sacId
     this.healthService.store(value).subscribe((res:any)=>{
         this.loading=false
         this.toastrService.success(res.message)
         this.getAll()
 
     },
     (err:any)=>{
       this.loading=false
 
         AppErrorShow.showError("Gestion des vaccinations",err)

     })
   }
   update(value:any){
     this.loading=true
     delete value.type
     this.healthService.update(this.selected_data.id,value).subscribe((res:any)=>{
       this.loading=false
 
         this.toastrService.success(res.message)
         this.getAll()
     },
     (err:any)=>{
       this.loading=false
 
       console.log(err)
         AppErrorShow.showError("Gestion des vaccinations",err)

     })
   }
   delete(id:any){
   //  if(!this.verifyIfElementChecked()) return ;
     let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
     confirmed.then((result:any)=>{
        if (result.isConfirmed) {
     this.healthService.delete(id).subscribe((res:any)=>{
         this.toastrService.success(res.message)
         this.getAll()
     },
     (err:any)=>{
       console.log(err)
         AppErrorShow.showError("Gestion des vaccinations",err)

     })
   }
 })
   }
   checked(el?:any){
     this.selected_data=el;
     this.is_active=el.status
   }

   verifyIfElementChecked(){
     console.log(this.selected_data)
     if (this.selected_data==null) {
       this.toastrService.warning("Aucun élément selectionné");
       return false;
     }
     return true;
   }
 
 
 
   dismiss(){
     this.modalService.dismissAll()
   }
 
   add(content:any){
   // if(!this.verifyIfElementChecked()) return ;
     this.modalService.open(content,{size:'lg'});
   }
 
 
   show(content:any){
     if(!this.verifyIfElementChecked()) return ;
     this.modalOption={centered:false,size:"lg"}
     this.modalService.open(content,{size:'lg'});
   }
 
   edit(content:any){
     if(!this.verifyIfElementChecked()) return ;
     this.modalService.open(content,{size:'lg'});
 
   }
 
   setStatus(value:any){
 
     this.toastrService.warning("Opération en cours")
   
         this.healthService.setState(this.selected_data.id,value).subscribe((res:any)=>{
           this.toastrService.success(res.message)
           this.getAll()
       },
       (err:any)=>{
         console.log(err)
           AppErrorShow.showError("Gestion des vaccinations",err)

       })
   }
   reject(value:any){
 
     this.toastrService.warning("Opération en cours")
   
         this.healthService.setState(this.selected_data.id,0).subscribe((res:any)=>{
           this.toastrService.success(res.message)
           this.getAll()
       },
       (err:any)=>{
         console.log(err)
           AppErrorShow.showError("Gestion des vaccinations",err)

       })
   }
 
   getPage(event:any){
     this.pg.p=event
   }
 
   getActions(){
     // this.buttonsPermission = {
     //   show:AppActionCheck.check(this.tag,'Consultation'),
     //   add:AppActionCheck.check(this.tag,'ajout'),
     //   edit:AppActionCheck.check(this.tag,'edition'),
     //   delete:AppActionCheck.check(this.tag,'suppression'),
     //   status:AppActionCheck.check(this.tag,'statut')
     // };
     this.buttonsPermission={
       show:true,
       add:true,
       edit:true,
       delete:true,
       status:true,
     }
   }

   getFile(path:any,css='details-panel'){
    this.pdfViewLoader=true
    this.spinnerService.show()
    this.fileService.get2({path:path,disk:'public'}).subscribe((res:any)=>{
      this.spinnerService.hide()
      this.pdfViewLoader=false
      this.pdfSrc=res[0]
      this.offcanvasService.open(this.contentPDF,{  panelClass: css, position: 'end'  });

    },
    (err:any)=>{
      this.spinnerService.hide()
      AppErrorShow.showError("Gestion des vaccinations",err)

    })
  }
}
